import React from "react";
import CheckDefecto from "../../../../Common/Components/CheckDefecto";

const EstaHabilitado = ({ data, selectCheckBox }) => {
    return (
        <div className="row top-separator-xs">
            <div className="col-xs-12">
                <CheckDefecto
                    nombre={"Habilitado"}
                    check={data.EstaHabilitado}
                    referencia={"ESTAHAB"}
                    selectCheckBox={(event) => selectCheckBox("EstaHabilitado", event.target.checked)}
                />
            </div>
        </div>
    );
}

export default EstaHabilitado;